import { Grid, Typography } from "@mui/material";
import React from "react";
import AppFooter from "../../components/AppFooter";
import AppWrapperContainer from "../../components/AppWrapperContainer";
import { DATA_STORAGE_POLICY } from "../../data/StaticList";
import mainBG from "../../public/assets/images/mainbg.webp";
import Seo from "../../components/Seo";

const ListItems = ({
  desc,
}: {
  desc: {
    text: string;
    points?: string[];
    pointsType?: "a" | "i" | "1" | "A" | "I";
  }[];
}) => {
  return (
    <Grid key={"GridContainer"}>
      {desc.map((d, i) => {
        return (
          <Grid key={`${i}_listItem`}>
            <li
              key={i}
              style={{
                fontSize: 17,
                paddingTop:
                  d.text == "Redemption GroMo Coins" ||
                  d.text ==
                    "GroMo Coins have an expiry of 3 months and the gromo coins will be expired on month end i.e. if a GroMo Partner earned 2000 GroMo Coins on 12th May, then those 2000 GroMo Coins will expire by 31st August."
                    ? "16px"
                    : "0",
              }}
            >
              {d.text}
            </li>
            <br />
            {d.points ? (
              <ol type={d.pointsType}>
                {d.points?.map((p, j) => {
                  return (
                    <Grid key={`${i}_${j}`}>
                      <li
                        style={{
                          fontSize: 15,
                          marginBottom: 2,
                        }}
                      >
                        {p}
                      </li>
                    </Grid>
                  );
                })}
              </ol>
            ) : null}
          </Grid>
        );
      })}
    </Grid>
  );
};

function TermCondition() {
  return (
    <>
      <Seo
        title="Data Storage Policy | GroMo"
        description="Download the GroMo app and become a partner to earn regular income by selling financial products. Start your online business with GroMo money making application"
        keywords="GroMo Money Making Application"
        openGraph={{
          title: "Data Storage Policy | GroMo",
          description:
            "Become a partner and make a regular income by selling financial products. Brand yourself as a certified financial advisor and launch and grow your business.",
          type: "website",
          image:
            "https://elasticbeanstalk-ap-south-1-812175807951.s3.ap-south-1.amazonaws.com/static-resources/notification-resources/notification_images/1668084562_Meta+Image-low+size.webp",
        }}
        twitter={{
          title: "Data Storage Policy | GroMo",
          description:
            "Become a partner and make a regular income by selling financial products. Brand yourself as a certified financial advisor and launch and grow your business.",
          url: "https://gromo.in/data-storage-policy",
          image:
            "https://elasticbeanstalk-ap-south-1-812175807951.s3.ap-south-1.amazonaws.com/static-resources/notification-resources/notification_images/1668084562_Meta+Image-low+size.webp",
        }}
      />
      <AppWrapperContainer nav navBgColor="white">
        <Grid
          paddingTop={4}
          style={{
            background: `url("${mainBG.src}")`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundAttachment: "fixed",
          }}
        >
          <Grid className="container">
            <>
              <Typography
                fontWeight={600}
                style={{
                  fontSize:'14px',
                  width: "fit-content",
                  borderBottom: "3px solid",
                  marginBottom: 16,
                }}
              >
                Data Storage Policy
              </Typography>
            </>
            <Grid
              style={{
                // maxWidth: 900,
                paddingBottom: "16px",
              }}
            >
              {DATA_STORAGE_POLICY.map((term, i) => {
                return (
                  <Grid
                    key={i}
                    style={{
                      padding: "12px 16px",
                      borderRadius: 8,
                      transition: "0.3s ease-in-out",
                      margin: "16px 0",
                    }}
                    sx={{
                      background: "#fffffff2",
                      boxShadow: "0px 0px 2px 0px grey",
                      ":hover": {
                        background: "#ffffff",
                        boxShadow: "0px 0px 3px 0px grey",
                      },
                    }}
                    id={term.title === "REFERRAL POLICY" ? "rp" : ""}
                  >
                    <Grid paddingBottom={2}>
                      <Typography sx = {{fontSize:'12px'}}>{term.title}</Typography>
                    </Grid>
                    <Grid>
                      {term.textType ? (
                        <ol
                          type={term.textType}
                          style={{
                            margin: 0,
                          }}
                        >
                          <ListItems desc={term.desc} />
                        </ol>
                      ) : (
                        <ul
                          style={{
                            listStyle: "none",
                            margin: 0,
                          }}
                        >
                          <ListItems desc={term.desc} />
                        </ul>
                      )}
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
        </Grid>
      </AppWrapperContainer>
      <AppFooter />
    </>
  );
}

export default TermCondition;
